import React, { memo } from 'react'
import Tooltip from '@material-ui/core/Tooltip'
import Skeleton from '@material-ui/lab/Skeleton'

import LittieCheckCircle from 'components/CommonUI/svgIcons/LittleRedCheckCircle'

const PerfomanceEnergyItem = ({
  title = '',
  value = null,
  range = [],
  unit = '',
  isFetching,
  tooltip,
  normal = '',
}) => {
  const [min, max] = range

  let classNameWorning = value < min || value > max ? 'warning' : ''
  if (normal === 'min') {
    classNameWorning = Math.min(value, ...range) !== value ? 'warning' : ''
  }

  const perString =
    normal === 'min' && max
      ? `(${Number((100 / max) * value).toFixed(2)}%)`
      : ''

  return (
    <div className="energy_item_container">
      <div className="left_section">
        <p className="card_title ">{title}</p>
        {!isFetching ? (
          <p
            className={`text ${classNameWorning}`}
          >{`${value} ${unit} ${perString}`}</p>
        ) : (
          <Skeleton variant="text" width={'80px'} />
        )}
      </div>
      {!isFetching ? (
        <Tooltip
            title={<span style={{ fontSize: '13px'}}>
        <span>{tooltip}</span>
        </span>}
            arrow
            placement="top">
          <div className="right_section">
            <LittieCheckCircle className="perfomance_item_icon" />
            <span className="perfomance_item_range">
              {min}-{max}
            </span>
          </div>
        </Tooltip>
      ) : (
        <Skeleton variant="text" width={'60px'} />
      )}
    </div>
  )
}

export default memo(PerfomanceEnergyItem)
